import Component from '../core/Component'
import EventBus from '../core/EventBus'
import { EVENTS } from '../core/Events'

export default class DocumentBase extends Component {
    constructor(element, options = {}) {
        super(element, options)

        this.ref = {
            filterWrap: null
        }
    }

    prepare() {
        document.addEventListener('nette:autosubmit', this.handleNetteAutosubmit)
        document.addEventListener('nette:form:valid', this.handleNetteFormValid)
        this.element.addEventListener('click', this.handleClick)
        EventBus.on(EVENTS.DOM_CHANGE, this.handleDomChange)
        this.checkNoResult()
    }

    destroy() {
        document.removeEventListener('nette:autosubmit', this.handleNetteAutosubmit)
        document.removeEventListener('nette:form:valid', this.handleNetteFormValid)
        EventBus.off(EVENTS.DOM_CHANGE, this.handleDomChange)
    }

    handleNetteFormValid = (event) => {
        const form = event.target
        this.checkFilterForm(form)
    }

    handleNetteAutosubmit = () => {
        this.checkFilterForm()
    }

    handleClick = () => {
        // this.element.classList.toggle('is-filtered')
    }

    handleDomChange = () => {
        this.checkNoResult()
        this.checkFilterForm()
    }

    checkFilterForm() {
        let isFormEmpty = true

        const form = this.ref.filterWrap.querySelector('form')
        if (form) {
            const formData = [...new FormData(form)]
            for (const pair of formData) {
                const [key, value] = pair

                if (key === 'do' || (key === 'query' && value == '') || !value) {
                    continue
                }

                isFormEmpty = false
                break
            }
        }

        if (isFormEmpty) {
            this.element.classList.remove('is-filtered')

            const filter = Component.getFromElement('filter')
            filter?.close()
        } else {
            this.element.classList.add('is-filtered')
        }
    }

    checkNoResult() {
        if (this.element.querySelector('.NoResult')) {
            this.element.classList.add('is-noresult')
        } else {
            this.element.classList.remove('is-noresult')
        }
    }
}